export const CARD_HEIGHT = 112;
export const CARD_WIDTH = 256;
export const COLUMN_HEADER_HEIGHT = 40;

export const pixel = (value: number): string => {
  return `${value}px`;
};

export const CARD_HEIGHT_PX = pixel(CARD_HEIGHT);
export const CARD_WIDTH_PX = pixel(CARD_WIDTH);

export const CardDimension = {
  height: CARD_HEIGHT,
  heightPx: CARD_HEIGHT_PX,
  width: CARD_WIDTH,
  widthPx: CARD_WIDTH_PX,
};

export const ItemDimension = {
  height: CardDimension.height + 8,
  width: CardDimension.width,
};
